export enum Dimension {
  WEEK = "Week",
  MONTH = "Month",
  QUARTER = "Quarter",
  YEAR = "Year",
}

export enum RatingType {
  PRACTICE = "Practice",
  ASSESSMENT = "Assessment",
}

export interface MetricQuery {
  startDate: Date;
  endDate: Date;
  dimension: Dimension;
  contentMetadataIds?: string[];
  countries?: string[];
  minSessionDurationInMinutes?: number;
}

export interface ExternalMetricQuery {
  startDate: Date;
  endDate: Date;
  dimension: Dimension;
  licenseIds: string[];
  minSessionDurationInMinutes?: number;
}

export interface MetricPoint {
  periodStart: Date;
  value: number;
}

export interface MetricSeries {
  points: MetricPoint[];
  aggregateValue: number;
}

export interface ActivityMetrics {
  hoursInVr: MetricSeries;
  uniqueUsers: MetricSeries;
  userSessions: MetricSeries;
  certifications: MetricSeries;
}

export interface CumulativeMetricSeries {
  hoursInVr: MetricSeries;
  uniqueUsers: MetricSeries;
  userSessions: MetricSeries;
}

export interface RatingValue {
  ratingType: RatingType;
  value: number;
  count: number;
}

export interface CountrySessionEntry {
  country: string;
  sessionCount: number;
}

export interface CountryHoursEntry {
  country: string;
  hoursInVr: number;
}

export interface CountryCertificationsEntry {
  country: string;
  certifications: number;
}

export interface ExperienceMetricPoint {
  experienceId: string;
  experienceName: string;
  uniqueUsers: number;
  hoursInVr: number;
  userSessions: number;
  certifications: number;
}

export interface ExperienceRating {
  experienceId: string;
  experienceName: string;
  values: RatingValue[];
}

export interface LicenseRating {
  licenseId: string;
  values: RatingValue[];
}

export interface RatingQuery {
  startDate: Date;
  endDate: Date;
  contentMetadataIds?: string[];
  countries?: string[];
}

export interface ExternalRatingQuery {
  startDate: Date;
  endDate: Date;
  licenseIds: string[];
}

export interface ExperienceRatingSeries {
  experiences: ExperienceRating[];
  aggregateValues: RatingValue[];
}

export interface LicenseRatingSeries {
  licenses: LicenseRating[];
  aggregateValues: RatingValue[];
}
